module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt5",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [(_vm.getProfile.role !== 'admin') ? _c('div', {
    staticClass: "pl-subheading mv2 ph4 pb3"
  }, [_c('span', [_vm._v("This is the suggestions page. Periodically, a member of the Parlay Team\n      will look at the analytics and engagement in your school / district and\n      make suggestions for how coaches and administrators can work with\n      teachers to deepen engagement with the Parlay, share best practices, and\n      continue to foster a culture of student-driven discussions. These\n      suggestions will also be sent in email format to relevant administrators\n      and coaches.")])]) : _vm._e(), _vm._v(" "), (_vm.getProfile.role === 'admin') ? _c('div', {
    staticClass: "new-suggestion",
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "id": "new-suggestion-btn"
    }
  }, [_c('pl-button', {
    staticClass: "pl-white justify-center",
    staticStyle: {
      "margin": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openTextEditor.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "create-new-image",
    attrs: {
      "src": "/static/course_assets/create_new_plus_sign.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#273248",
      "padding": "5px",
      "font-weight": "600"
    }
  }, [_vm._v("New Suggestion")])])], 1) : _vm._e(), _vm._v(" "), (_vm.openEditor) ? _c('div', {
    staticClass: "tiny-mce-container"
  }, [_c('div', {
    staticClass: "suggestions-inner-container"
  }, [_c('tinymce', {
    staticStyle: {
      "height": "80% !important",
      "width": "100%"
    },
    attrs: {
      "toolbarOptions": _vm.toolbar_options,
      "savedContent": _vm.prompt_response,
      "statusBar": false,
      "draftResponse": _vm.saved_response
    },
    on: {
      "change": _vm.handleResponseChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap relative items-center submission-form-bottom-row mv2"
  }, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "max-width": "400px",
      "max-height": "100px"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "100px",
      "text-align": "center",
      "font-size": "14px",
      "margin": "auto",
      "padding": "5px",
      "font-weight": "600",
      "color": "#273248"
    }
  }, [_vm._v("Email To:\n          ")]), _vm._v(" "), (_vm.coachesAdmins) ? _c('div', [_c('pl-multiselect', {
    staticClass: "flex mv2",
    attrs: {
      "options": _vm.coachesAdmins,
      "multiple": true,
      "custom-label": _vm.nameWithEmail,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "preselect-first": false,
      "label": "name",
      "placeholder": "Select coaches/admins",
      "track-by": "id"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.selectedEmails && _vm.selectedEmails.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v("\n                  " + _vm._s(_vm.selectedEmails.length) + " options selected\n                ")]) : _vm._e()]
      }
    }], null, false, 758886715),
    model: {
      value: (_vm.selectedEmails),
      callback: function($$v) {
        _vm.selectedEmails = $$v
      },
      expression: "selectedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-grow h-100 items-center justify-end"
  }, [_c('pl-button', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: ('Close editor'),
      expression: "'Close editor'"
    }],
    staticClass: "edit-submission-exit-button b",
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditor.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            CANCEL\n          ")]), _vm._v(" "), _c('pl-button', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: ('Save suggestion'),
      expression: "'Save suggestion'"
    }],
    staticClass: "pl-white b",
    attrs: {
      "disabled": _vm.is_saving || !_vm.recent_changes
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitSuggestion(true)
      }
    }
  }, [_vm._v("\n            SAVE\n          ")]), _vm._v(" "), _c('pl-button', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: ('Send suggestion'),
      expression: "'Send suggestion'"
    }],
    staticClass: "pl-primary edit-submission-exit-button b",
    attrs: {
      "disabled": _vm.is_saving ||
        (!_vm.recent_changes &&
          !_vm.selectedSuggestionDrafted &&
          _vm.emails_changed)
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitSuggestion(false)
      }
    }
  }, [_vm._v("\n            SEND\n          ")])], 1)])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "suggestions-container"
  }, _vm._l((_vm.visible_suggestions), function(suggestion, index) {
    return _c('div', {
      key: index,
      staticClass: "suggestion-card shadow-3"
    }, [_c('suggestion-card', {
      attrs: {
        "suggestion": suggestion,
        "isNewSuggestion": suggestion.isNew
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.show_delete_suggestion_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Suggestion"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_suggestion_modal = false
      },
      "actionConfirmed": _vm.confirmDeleteSuggestion
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3b6512c0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/suggestions/suggestionsTab.vue
// module id = 2017
// module chunks = 61